module.exports = __webpack_public_path__ + "img/times.96c92601.svg";